import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Spinner from './formcomponents/Spinner';
import { useNavigate } from 'react-router-dom';
import { set } from 'date-fns';
import ImageAuthorized from './formcomponents/ImageAuthorized';

export default function Bio({
  nextStep,
  prevStep,
  maxSteps,
  step,
  formData,
  setFormData,
}) {
  const [errorMessage, setErrorMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState(null);

  // load initial values from server if user has already entered data previously
  useEffect(() => {
    // if no register token take back to register page
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/register', { replace: true });
    }

    // if user has already entered profile - get data from server
    let userId = localStorage.getItem('userId');
    if (!userId) {
      // if admin/staff updating user profile for uat / testing
      userId = localStorage.getItem('staffId');
    }
    const url = `${process.env.REACT_APP_API_URL}/bio/${userId}`;
    console.debug('url: ', url);
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    setLoading(true);

    axios
      .get(url, { headers })
      .then((res) => {
        console.log(res.data);
        if (res.data) {
          // dont reset whole of form data if user has gone to next screen & back
          const updatedFormData = { ...formData };
          for (const key in res.data) {
            if (key === 'latest_image_path') {
              setImage(res.data[key]);
            } else {
              updatedFormData[key] = res.data[key];
            }
          }
          setFormData(updatedFormData);
          console.log('formData', formData);
        } else {
          console.log('No data found on server');
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(err.message);
        setLoading(false);
      });
  }, []);

  const saveToServerDbAndMoveToNextStep = () => {
    // if no register token take back to register page
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/register', { replace: true });
    }

    // if user has already entered profile - get data from server
    let userId = localStorage.getItem('userId');
    if (!userId) {
      // if admin/staff updating user profile for uat / testing
      userId = localStorage.getItem('staffId');
    }
    const url = `${process.env.REACT_APP_API_URL}/bio/${userId}`;
    console.debug('url: ', url);
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    setLoading(true);

    axios
      .post(url, formData, { headers })
      .then((res) => {
        console.log(res.data);
        nextStep();
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setErrorMessage(err.response.data.error);
        setLoading(false);
      });
  };

  const handleFileChange = (event) => {
    console.log(event.target.files);
    const file = event.target.files[0];
    if (file) {
      const fileSize = file.size / 1024 / 1024; // in MB
      console.log('file size: ', fileSize);
      const fileType = file.type.split('/')[0]; // getting the file type

      if (fileSize > 4) {
        setErrorMessage('File size exceeds 4MB');
        setSelectedFile(null);
      } else if (fileType !== 'image') {
        setErrorMessage('File is not an image');
        setSelectedFile(null);
      } else {
        setErrorMessage('');
        setSelectedFile(file);
      }
    }
  };

  
  const handleImageUpload = async (event) => {
    event.preventDefault();
    if (selectedFile == null) {
      alert('Please select a file');
      return;
    }

    const formData = new FormData();
    formData.append('image', selectedFile);

    // if no register token take back to register page
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/register', { replace: true });
    }

    // if user has already entered profile - get data from server
    let userId = localStorage.getItem('userId');
    if (!userId) {
      // if admin/staff updating user profile for uat / testing
      userId = localStorage.getItem('staffId');
    }
    const url = `${process.env.REACT_APP_API_URL}/images/${userId}`;
    console.debug('url: ', url);
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    };

    setLoading(true);

    const response = await axios.post(url, formData, {
      headers: headers,
    });

    console.log(response.data);
    setImage(response.data.imagePath);
    setLoading(false);
  };

  // Ensure formData has default values to avoid undefined
  const defaultFormData = {
    body_type: formData.body_type || '',
    profession: formData.profession || '',
    children: formData.children || '',
    age_of_children: formData.age_of_children || '',
    eye_color: formData.eye_color || '',
    hair_color: formData.hair_color || '',
    smoking_habit: formData.smoking_habit || '',
    drinking_habit: formData.drinking_habit || '',
    religion: formData.religion || '',
    religion_others: formData.religion_others || '',
    describe_religion: formData.describe_religion || '',
    describe_religion_others: formData.describe_religion_others || '',
    height: formData.height || '',
    weight: formData.weight || '',
    willing_to_relocate: formData.willing_to_relocate || '',
    willing_to_relocate_conditions: formData.willing_to_relocate_conditions || '',
  };
  console.log('Amma', defaultFormData);
  const imagePath = `${process.env.REACT_APP_API_URL}${image}`;
  console.log(imagePath);

  return (
    <div className='container mt-5'>
      <div className='error'>{errorMessage}</div>
      {loading && <Spinner />}
      <div className='row'>
        {/* Body type */}
        <div className='col-md-6 col-sm-12'>
          Body Type
          <br />
          <select
            class='form-control'
            id='body_type'
            value={defaultFormData.body_type}
            onChange={(e) =>
              setFormData({ ...formData, body_type: e.target.value })
            }
          >
            <option value=''>Please select</option>
            <option value='9700'>About Average</option>
            <option value='9701'>Athletic and Toned</option>
            <option value='9702'>Full Figured</option>
            <option value='9703'>Heavyset</option>
          </select>
        </div>

        {/* Profession */}
        <div className='col-md-6 col-sm-12'>
          Profession
          <br />
          <select
            class='form-control'
            id='profession'
            value={defaultFormData.profession}
            onChange={(e) =>
              setFormData({ ...formData, profession: e.target.value })
            }
          >
            <option value=''>Please Select</option>
            <option value='10300'>Accountant</option>
            <option value='10301'>Actuary</option>
            <option value='10302'>Academician</option>
            <option value='10303'>Advertising</option>
            <option value='10304'>Anthropologist</option>
            <option value='10305'>Auditor</option>
            <option value='10306'>Aviation</option>
            <option value='10307'>Archeologist</option>
            <option value='10308'>Architect</option>
            <option value='10309'>Artist</option>
            <option value='10400'>Banker</option>
            <option value='10401'>Biologist</option>
            <option value='10402'>Botanist</option>
            <option value='10403'>Broadcaster</option>
            <option value='10404'>Business owner</option>
            <option value='10405'>Chemist</option>
            <option value='10406'>Charter Agent / Ship Broker </option>
            <option value='10407'>Chemical Researcher</option>
            <option value='10408'>Chemical Engineer</option>
            <option value='10409'>CEO/C-suite executive</option>
            <option value='10410'>Choreographer</option>
            <option value='10411'>Coach</option>
            <option value='10412'>Computer Programmer </option>
            <option value='10413'>Composer</option>
            <option value='10414'>Conservator</option>
            <option value='10415'>Dancer</option>
            <option value='10416'>Dentist</option>
            <option value='10417'>Doctor</option>
            <option value='10418'>Dietitian</option>
            <option value='10419'>Developer</option>
            <option value='10420'>Director </option>
            <option value='10421'>Ecologist</option>
            <option value='10422'>Economist</option>
            <option value='10423'>Editor </option>
            <option value='10424'>Educator</option>
            <option value='10425' selected=''>
              Engineer
            </option>
            <option value='10426'>Entrepreneur</option>
            <option value='10427'>Environmentalist</option>
            <option value='10428'>Exhibitions Manager</option>
            <option value='10429'>Fashion Designer</option>
            <option value='10430'>Film Critic / Film Maker </option>
            <option value='10431'>Financier </option>
            <option value='10432'>Financial Analyst</option>
            <option value='10433'>Food Industry Technologist</option>
            <option value='10434'>General Anesthetist</option>
            <option value='10435'>General Practitioner</option>
            <option value='10436'>Geologist</option>
            <option value='10437'>Geophysicist</option>
            <option value='10438'>Goldsmith</option>
            <option value='10439'>Government</option>
            <option value='10440'>Hotelier</option>
            <option value='10441'>Herbalist</option>
            <option value='10442'>Industrial engineer</option>
            <option value='10443'>IT</option>
            <option value='10444'>Insurance</option>
            <option value='10445'>Investment Officer</option>
            <option value='10446'>Investor</option>
            <option value='10447'>Image Consultant</option>
            <option value='10448'>Jeweler</option>
            <option value='10449'>Judge</option>
            <option value='10450'>Journalist</option>
            <option value='10451'>Lawyer</option>
            <option value='10452'>Lecturer</option>
            <option value='10453'>Management consultant</option>
            <option value='10454'>Marine Engineer</option>
            <option value='10455'>Mathematician</option>
            <option value='10456'>Mechanic</option>
            <option value='10457'>Money Broker</option>
            <option value='10458'>Microbiologist</option>
            <option value='10459'>Miner / Mining </option>
            <option value='10460'>Model</option>
            <option value='10461'>Multimedia designer</option>
            <option value='10462'>Musician</option>
            <option value='10463'>News Editor</option>
            <option value='10464'>Nutritionist</option>
            <option value='10465'>Nurse</option>
            <option value='10466'>Optician</option>
            <option value='10467'>Obstetrician &amp; Gynecologist</option>
            <option value='10468'>Orthopedic Surgeon</option>
            <option value='10469'>Orthodontist</option>
            <option value='10470'>Pediatrician</option>
            <option value='10471'>Politician</option>
            <option value='10472'>Pharmacist</option>
            <option value='10473'>Philosopher</option>
            <option value='10474'>Photographer</option>
            <option value='10475'>Physicist</option>
            <option value='10476'>Pharmacist</option>
            <option value='10477'>Pilot</option>
            <option value='10478'>Political Scientist</option>
            <option value='10479'>Producer</option>
            <option value='10480'>Psychologist</option>
            <option value='10481'>Psychotherapist</option>
            <option value='10482'>Publisher</option>
            <option value='10483'>Public Relations</option>
            <option value='10484'>Radiologist</option>
            <option value='10485'>Railway Engineer</option>
            <option value='10486'>Sales and Marketing</option>
            <option value='10487'>Scientist</option>
            <option value='10488'>Safety Engineer</option>
            <option value='10489'>Sculptor</option>
            <option value='10490'>School Inspector</option>
            <option value='10491'>Script Writer</option>
            <option value='10492'>Spa Owner</option>
            <option value='10493'>Stockbroker</option>
            <option value='10494'>Systems Engineer</option>
            <option value='10495'>Teacher</option>
            <option value='10496'>Tax Adviser / Tax Specialist </option>
            <option value='10497'>Valuer</option>
            <option value='10498'>Veterinarian </option>
            <option value='10499'>Viniculturist </option>
            <option value='10599'>Others </option>
            <option value='104100'>Real Estate</option>
          </select>
        </div>

        {/* Children */}
        <div className='col-md-6 col-sm-12'>
          Children
          <select
            class='form-control'
            id='children'
            onChange={(e) =>
              setFormData({ ...formData, children: e.target.value })
            }
            value={defaultFormData.children}
          >
            <option value=''>Please Select</option>
            <option value='9800'>0</option>
            <option value='9801'>1</option>
            <option value='9802'>2</option>
            <option value='9803'>3</option>
            <option value='9804'>More than 3</option>
          </select>
        </div>

        {/* Age of Children */}
        <div
          className='col-md-6 col-sm-12'
          hidden={
            defaultFormData.children === '9800' ||
            defaultFormData.children === ''
          }
        >
          Age Of Children
          <input
            type='text'
            className='form-control'
            placeholder={
              defaultFormData.children === '9801'
                ? 'enter age'
                : 'enter age of children separated by comma'
            }
            onChange={(e) =>
              setFormData({ ...formData, age_of_children: e.target.value })
            }
            value={defaultFormData.age_of_children}
          />
        </div>

        {/* {Eye colour} */}
        <div className='col-md-6 col-sm-12'>
          Eye Colour
          <select
            class='form-control'
            value={defaultFormData.eye_color}
            onChange={(e) =>
              setFormData({ ...formData, eye_color: e.target.value })
            }
            id='eye'
          >
            <option value=''>Please Select</option>
            <option value='9900'>Aqua</option>
            <option value='9901' selected=''>
              Black
            </option>
            <option value='9902'>Blue</option>
            <option value='9903'>Brown</option>
            <option value='9904'>Green</option>
            <option value='9905'>Grey</option>
            <option value='9906'>Others</option>
          </select>
        </div>

        {/* { Hair colour} */}
        <div className='col-md-6 col-sm-12'>
          Hair Color
          <select
            value={defaultFormData.hair_color}
            onChange={(e) =>
              setFormData({ ...formData, hair_color: e.target.value })
            }
            class='form-control'
          >
            <option value=''>Please Select</option>
            <option value='10100'>Auburn</option>
            <option value='10101'>Black</option>
            <option value='10102'>Blonde</option>
            <option value='10103'>Brown</option>
            <option value='10104'>Red</option>
            <option value='10105' selected=''>
              Salt and Pepper
            </option>
            <option value='10106'>Others</option>
          </select>
        </div>

        {/* {Smoking habit} */}
        <div className='col-md-6 col-sm-12'>
          Smoking Habit
          <select
            value={defaultFormData.smoking_habit}
            onChange={(e) =>
              setFormData({ ...formData, smoking_habit: e.target.value })
            }
            class='form-control'
          >
            <option value=''>Please Select</option>

            <option value='10000' selected=''>
              Non-smoker
            </option>

            <option value='10001'>Smoker</option>

            <option value='10002'>Social Smoker</option>
          </select>
        </div>

        {/* Drinking habit */}
        <div className='col-md-6 col-sm-12'>
          Drinking Habit
          <select
            value={defaultFormData.drinking_habit}
            onChange={(e) => {
              setFormData({ ...formData, drinking_habit: e.target.value });
            }}
            class='form-control'
          >
            <option value=''>Please Select</option>
            <option value='10200'>Drinker</option>
            <option value='10201'>Non-Drinker</option>
            <option value='10202'>Social Drinker</option>
          </select>
        </div>

        {/* Religion */}
        <div className='col-md-6 col-sm-12'>
          Religion
          <select
            value={defaultFormData.religion}
            onChange={(e) => {
              setFormData({ ...formData, religion: e.target.value });
            }}
            class='form-control'
          >
            <option value=''>Please Select</option>
            <option value='11001'>Buddhism</option>
            <option value='11002'>Christianity</option>
            <option value='11003'>Catholicism</option>
            <option value='11004'>Free Thinker</option>
            <option value='11005'>Hinduism</option>
            <option value='11006'>Judaism</option>
            <option value='11007'>Islam</option>
            <option value='11008'>No Religion</option>
            <option value='11009'>Zoroastrianism</option>
            <option value='11010'>Others</option>
          </select>
          <input
            hidden={defaultFormData.religion !== '11010'}
            type='text'
            placeholder='Please type other religion'
            className='form-control'
            onChange={(e) =>
              setFormData({ ...formData, religion_others: e.target.value })
            }
            value={defaultFormData.religion_others}
          />
        </div>

        {/* how religious are you? */}
        <div className='col-md-6 col-sm-12'>
          How Religious Are You
          <select
            value={defaultFormData.describe_religion}
            onChange={(e) => {
              setFormData({ ...formData, describe_religion: e.target.value });
            }}
            className='form-control '
          >
            <option value=''>Please Select</option>
            <option value='10600'>Extremely Religious</option>
            <option value='10601'>Moderately Religious</option>
            <option value='10602'>Religious</option>
            <option value='10603'>Spiritual but not Religious</option>
            <option value='10604'>Not-Religious</option>
            <option value='10605'>not spiritual and not religious</option>
            <option value='10606'>Others</option>
          </select>
        </div>

         {/* height */}
         <div className='col-md-6 col-sm-12'>
          height
          <input
            value={defaultFormData.height}
            onChange={(e) => {
              setFormData({ ...formData, height: e.target.value });
            }}
            className='form-control '
          >
           
          </input>
        </div>

        {/* Weight */}
        <div className='col-md-6 col-sm-12'>
          weight
          <input
            value={defaultFormData.weight}
            onChange={(e) => {
              setFormData({ ...formData, weight: e.target.value });
            }}
            className='form-control '
          >
           
          </input>
        </div>

         {/* Willing to relocate */}
         <div className='col-md-6 col-sm-12'>
          Willing to relocate
          <select
            value={defaultFormData.willing_to_relocate}
            onChange={(e) => {
              setFormData({ ...formData, willing_to_relocate: e.target.value });
            }}
            class='form-control'
          >
            <option value=''>Please Select</option>
            <option value="Yes, absolutely" selected="">Yes, absolutely</option>
            <option value="Yes, but with conditions">Yes, but with conditions</option>
            <option value="No">No</option>
          </select>
          <textarea
            hidden={defaultFormData.willing_to_relocate !== 'Yes, but with conditions'}
            type='text'
            placeholder='Please share your conidtions'
            className='form-control'
            onChange={(e) =>
              setFormData({ ...formData, willing_to_relocate_conditions: e.target.value })
            }
            value={defaultFormData.willing_to_relocate_conditions}
          ></textarea>
        </div>
        

        {/* languages */}
        <div className='col-md-6 col-sm-12'>
          Languages you can speak
          <input
            value={defaultFormData.languages}
            onChange={(e) => {
              setFormData({ ...formData, languages: e.target.value });
            }}
            className='form-control '
          >
           
          </input>
        </div>
      </div>

      <div className='row'>
        <form className='form-control' onSubmit={handleImageUpload}>
          <div className='mb-3'>
            <label className='form-label'>Profile photo</label>
            <input type='file' accept='image/*' onChange={handleFileChange} />
          </div>
          <button type='submit' className='btn btn-primary'>
            Upload
          </button>
        </form>
      </div>

      <div>
        <ImageAuthorized 
          src={imagePath}
          style={{width:'90%' , maxWidth:'400px', padding:'10px', borderRadius:'50px'}}
          alt="Profile"
        />
      </div>

      <div className='error'>{errorMessage}</div>

      <div className='footer'>
        <button className='navigate' disabled={step === 0} onClick={prevStep}>
          Prev
        </button>
        <button
          className='navigate'
          disabled={step === maxSteps}
          onClick={saveToServerDbAndMoveToNextStep}
        >
          Next
        </button>
      </div>
    </div>
  );
}
